import React from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"

import {
	Row,
	Col,
	Form,
	FormGroup,
	FormText,
	Input,
	InputGroup,
	InputGroupAddon,
	Label,
	UncontrolledModal,
	ModalHeader,
	ModalBody,
	ModalFooter,
} from "../../../../components"

import * as ACTIONS from "../../../../store/actions"
import * as clearview from "../../../../components/@Clearview"
import AttributesTable from "./AttributesTable"

class AddProperty_Form extends React.Component {
	static propTypes = {
		client: PropTypes.object.isRequired,
		doAction: PropTypes.func.isRequired,
	}

	constructor(props) {
		super(props)

		this.state = {
			type: "Property",
			lft: props.client.rgt,
			rgt: props.client.rgt,
		}
		this.props = props

		this.handleActionButtonClick = this.handleActionButtonClick.bind(this)
		this.handleChange = this.handleChange.bind(this)
		this.isPropertyRequired = this.isPropertyRequired.bind(this)
	}

	handleActionButtonClick(e) {
		clearview.StopPropagation(e)

		if (!this.isValid) {
			this.setState({ showValidation: true })
			return
		}

		const newProperty = {
			reference: this.state.reference,
			name: this.state.name,
			attributes: this.state.attributes,
			address: {
				fullAddressExcludingPostcode: this.state["address.fullAddressExcludingPostcode"],
				postcode: this.state["address.postcode"],
			},
		}

		this.props.doAction(this.props.client, newProperty)
		this.setState({})
		return true
	}

	handleChange(e) {
		const value = e.target.name === "address.postcode" && e.target.value ? e.target.value.toUpperCase() : e.target.value

		this.setState({
			[e.target.name]: value,
		})
	}

	isPropertyRequired(propertyName) {
		return this.state[propertyName] === undefined || !this.state[propertyName].length
	}

	get isValid() {
		return (
			!this.isPropertyRequired("reference") &&
			!this.isPropertyRequired("name") &&
			!this.isPropertyRequired("address.fullAddressExcludingPostcode") &&
			!this.isPropertyRequired("address.postcode")
		)
	}

	render() {
		const { client } = this.props

		const pageSpec = { maxWidth: 750, col1: 6, col2: 6 }

		return (
			<UncontrolledModal style={{ maxWidth: pageSpec.maxWidth }} target="AddProperty_Form">
				<Form onSubmit={this.handleSubmit}>
					<ModalHeader tag="div">
						<div className="d-flex">
							<h1 className="text-primary mr-2">{clearview.Icon.client.Client}</h1>
							<h6>
								Add <b>Property</b> to <b className="nowrap">{client.name}</b>
							</h6>
						</div>
					</ModalHeader>

					<ModalBody>
						<Row className="mb-0">
							<Col lg={pageSpec.col1}>
								<FormGroup row>
									<InputGroup>
										<InputGroupAddon addonType="prepend">Ref:</InputGroupAddon>
										<Input
											invalid={this.state.showValidation && this.isPropertyRequired("reference")}
											type="text"
											name="reference"
											id="reference"
											placeholder="Ref..."
											value={this.state.reference}
											onKeyDown={clearview.ValidRefCharacters}
											onChange={this.handleChange}
										/>
									</InputGroup>
									<FormText hidden={!this.state.showValidation || !this.isPropertyRequired("reference")} className="text-danger">
										Ref is required and must be unique
									</FormText>
								</FormGroup>
								<FormGroup row>
									<InputGroup>
										<InputGroupAddon addonType="prepend">Name:</InputGroupAddon>
										<Input
											invalid={this.state.showValidation && this.isPropertyRequired("name")}
											type="text"
											name="name"
											id="name"
											placeholder="Name..."
											value={this.state.name}
											onChange={this.handleChange}
										/>
									</InputGroup>
									<FormText hidden={!this.state.showValidation || !this.isPropertyRequired("name")} className="text-danger">
										Name is required and must be unique
									</FormText>
								</FormGroup>

								<FormGroup row>
									<Label>Address:</Label>
								</FormGroup>

								<FormGroup row>
									<InputGroup>
										<InputGroupAddon addonType="prepend">Address:</InputGroupAddon>
										<Input
											invalid={this.state.showValidation && this.isPropertyRequired("address.fullAddressExcludingPostcode")}
											type="textarea"
											name="address.fullAddressExcludingPostcode"
											id="address.fullAddressExcludingPostcode"
											placeholder="Full Address Excluding Postcode..."
											value={this.state["address.fullAddressExcludingPostcode"]}
											onChange={this.handleChange}
											rows={6}
										/>
									</InputGroup>
									<FormText
										hidden={!this.state.showValidation || !this.isPropertyRequired("address.fullAddressExcludingPostcode")}
										className="text-danger"
									>
										Address is required
									</FormText>
								</FormGroup>
								<FormGroup row>
									<InputGroup>
										<InputGroupAddon addonType="prepend">Postcode:</InputGroupAddon>
										<Input
											invalid={this.state.showValidation && this.isPropertyRequired("address.postcode")}
											type="text"
											name="address.postcode"
											id="address.postcode"
											placeholder="Postcode..."
											value={this.state["address.postcode"]}
											onChange={this.handleChange}
										/>
									</InputGroup>
									<FormText hidden={!this.state.showValidation || !this.isPropertyRequired("address.postcode")} className="text-danger">
										Postcode is required
									</FormText>
								</FormGroup>
							</Col>

							<Col lg={pageSpec.col2} hidden={pageSpec.col2 === 0}>
								<FormGroup>
									<AttributesTable
										key="attributesTableEdit"
										business={this.state}
										isEditing={true}
										name="attributes"
										onChange={this.handleChange}
									/>
								</FormGroup>
							</Col>
						</Row>
					</ModalBody>

					<ModalFooter>
						<UncontrolledModal.Cancel color="link" className="text-primary">
							Cancel
						</UncontrolledModal.Cancel>
						<UncontrolledModal.Close color="default" className="text-primary" onClick={this.handleActionButtonClick}>
							Add Property
						</UncontrolledModal.Close>
					</ModalFooter>
				</Form>
			</UncontrolledModal>
		)
	}
}

const mapDispatchToProps = dispatch => ({
	doAction: (parent, property) =>
		dispatch({
			type: ACTIONS.PROPERTY_ADD,
			parent: parent,
			property: property,
		}),
})

export default connect(null, mapDispatchToProps)(AddProperty_Form)
